import { EVENT_CATEGORY } from "@lululemon/mwa-analytics";
export var PEPS_PROFILE_STORAGE_NAME = "ecom-web-app-profile";
export var AFFINITY_GENDER = "genderAffinity";
export var UNKNOWN_AFFINITY_VALUE = "unknown";
export var CURRENT_AFFINITY_KEY = "current";
export var EVENT_PAGE_VIEW = EVENT_CATEGORY.PAGE_VIEW;
export var EVENT_STORY_PAGE_DATA = "story-page-data";
export var EVENT_CATEGORY_DETAIL_PAGE_DATA = "category-page-data";
export var EVENT_PRODUCT_DETAIL_PAGE_DATA = "product-detail-page-data";
export var EVENT_PDP_ADD_TO_BAG = "pdp-add-to-bag";
export var EVENT_PDP_ADD_TO_CART = "pdp-add-to-cart";
export var EVENT_CDP_CLICK_PRODUCT_TILE = "cdp-click-product-tile";
export var AFFINITY_TYPES = [
    AFFINITY_GENDER,
    "colorAffinity",
    "activityAffinity",
    "categoryAffinity",
    "collectionAffinity",
    "giftingAffinity"
];
export var EVENT_PRODUCT_INTERACTION = EVENT_CATEGORY.PRODUCT_INTERACTION;
